import { MainContainerComponent } from './common/containers/main-container.component';
import { MonlogsDetailContainerComponent } from './monlogs/containers/monlogs-detail-container.component';
import { MonLogPrintContainerComponent } from './monlogs/containers/mon-log-print-container.component';
import { MonlogsAllLogsSearchContainerComponent } from './monlogs/containers/monlogs-all-logs-search-container.component';
import { OplogsDetailContainerComponent } from './operational-monitoring/containers/oplogs-detail-container/oplogs-detail-container.component';
import { OpAlertLogPrintContainerComponent } from './operational-monitoring/containers/op-alert-log-print-container/op-alert-log-print-container.component';
import { OplogsAllLogsSearchContainerComponent } from './operational-monitoring/containers/oplogs-all-logs-search-container/oplogs-all-logs-search-container.component';
import { FacilityContainerComponent } from './locations/containers/facility-container/facility-container.component';
import { FacilityDetailsContainerComponent } from './locations/containers/facility-container/facility-details-container.component';
import { LocationContainerComponent } from './locations/containers/location-container/location-container.component';
import { ContactProfileContainerComponent } from './contacts/containers/contact-profile/contact-profile-container.component';
import { ContactsSearchContainerComponent } from './contacts/containers/contacts-search/contacts-search-container.component';
import { ContactListSearchContainerComponent } from './contacts/containers/contact-list-search/contact-list-search-container.component';
import { ContactDetailsContainerComponent } from './contacts/containers/contact-details/contact-details-container.component';
import { ContactListDetailViewContainerComponent } from './contacts/containers/contact-list-detail-view/contact-list-detail-view-container.component';
import { ExternalContactListDetailsContainerComponent } from './contacts/containers/external-contact-list-details/external-contact-list-details-container.component';
import { ExternalContactListSearchContainerComponent } from './contacts/containers/external-contact-list-search/external-contact-list-search-container.component';
import { NoteFormComponent } from './crm/containers/controller-notes/note-form/note-form.component';
import { SapOutageReportComponent } from './reporting/sap-outage-report/sap-outage-report.component';
import { ReadOnlySapViewComponent } from './reporting/components/read-only-sap-view/read-only-sap-view.component';
import { McLogSearchComponent } from './monlogs/components/mc-log-search/mc-log-search.component';
import { McLogDetailsComponent } from './monlogs/components/mc-log-details/mc-log-details.component';
import { MonlogsSearchContainerComponent } from './monlogs/containers/monlogs-search-container.component';
import { AlarmLimitsSearchContainerComponent } from './operational-monitoring/containers/alarm-limits-search-container/alarm-limits-search-container.component';
import { SyncAlarmLimitsContainerComponent } from './operational-monitoring/containers/sync-alarm-limits-container/sync-alarm-limits-container.component';
import { StationLogsSearchContainerComponent } from './operational-monitoring/containers/station-logs/station-logs-search-container.component';
import { McShiftTurnoverContainerComponent } from './monlogs/containers/mc-shift-turnover-container.component';
import { MusterListSearchContainerComponent } from './operational-monitoring/containers/muster-list-search-container/muster-list-search-container.component';
import { McShiftTurnoverDetailComponent } from './monlogs/containers/mc-shift-turnover-detail.component';
import { McShiftTurnoverPrintContainerComponent } from './monlogs/containers/mc-shift-turnover-print-container.component';
import { ContactListCreateContainerComponent } from './contacts/containers/contact-list-create/contact-list-create-container.component';
import { GisMapComponent } from './maps/gis-map/gis-map.component';
import { FieldVisionEmbedComponent } from './maps/field-vision-embed/field-vision-embed.component';
import { ControllerNotesContainerComponent } from './crm/containers/controller-notes-container/controller-notes-container.component';
import { DailyOperatingPlansContainerComponent } from './crm/containers/daily-operating-plans/daily-operating-plans-container.component';
import { AorViewComponent } from './crm/containers/controller-notes/aor-view.component';
import { CrmShiftTurnoverContainerComponent } from './crm/containers/crm-shift-turnover-container/crm-shift-turnover-container.component';
import { CrmShiftTurnoverDetailsContainerComponent } from './crm/containers/crm-shift-turnover-details-container/crm-shift-turnover-details-container.component';
import { CrmShiftTurnoverPrintContainerComponent } from './crm/containers/crm-shift-turnover-print-container/crm-shift-turnover-print-container.component';
import { EmailGroupContainerComponent } from './admin/containers/email-group-container/email-group-container.component';
import { MonLogTypesContainerComponent } from './admin/containers/mon-log-types-container/mon-log-types-container.component';
import { NoteTypesContainerComponent } from './admin/containers/note-types-container/note-types-container.component';
import { JobRolesContainerComponent } from './admin/containers/job-roles-container/job-roles-container.component';
import { CompanyContainerComponent } from './admin/containers/company-container/company-container.component';
import { MocEventSearchContainerComponent } from './crm/containers/moc-event-search-container/moc-event-search-container.component';
import { MocEventDetailsContainerComponent } from './crm/containers/moc-event-details-container/moc-event-details-container.component';
import { RoleClaimAssignContainerComponent } from './admin/containers/roles/role-claim-container/role-claim-assign-container.component';
import { ClaimRoleAssignContainerComponent } from './admin/containers/roles/claim-role-container/claim-role-assign-container.component';
import { RoleBusinessUnitAssignContainerComponent } from './admin/containers/roles/role-business-units-container/role-business-unit-assign-container.component';
import { AreaDetailsContainerComponent } from './locations/containers/area-container/area-details-container.component';
import { AreaContainerComponent } from './locations/containers/area-container/area-container.component';
import { MocEventCategoryContainerComponent } from './admin/containers/moc-event-category-container/moc-event-category-container.component';
import { RegionContainerComponent } from './locations/containers/region-container/region-container.component';
import { RegionDetailsContainerComponent } from './locations/containers/region-container/region-details-container.component';
import { PartsSearchContainerComponent } from './operational-monitoring/containers/parts-search-container/parts-search-container.component';
import { TroubleshootingSearchContainerComponent } from './operational-monitoring/containers/troubleshooting-search-container/troubleshooting-search-container/troubleshooting-search-container.component';
import { MobileControllerNotesSearchComponent } from './crm/containers/mobile-controller-notes-search/mobile-controller-notes-search.component';
import { MobileNoteFormComponent } from './crm/containers/mobile-note-form/mobile-note-form.component';
import { FacilityVisitorLogComponent } from './locations/components/facility-visitor-log/facility-visitor-log.component';
import { CommercialContactsSearchContainerComponent } from './commercial-services/containers/commercial-contacts-search/commercial-contacts-search-container.component';
import { CommercialContactDetailsContainerComponent } from './commercial-services/containers/commercial-contact-details/commercial-contact-details-container.component';
import { CommercialFacilitiesSearchContainerComponent } from './commercial-services/containers/commercial-facilities-search/commercial-facilities-search-container.component';
import { CommercialFacilityDetailsContainerComponent } from './commercial-services/containers/commercial-facility-details/commercial-facility-details-container.component';
import { CommercialOutagesSearchContainerComponent } from './commercial-services/containers/commercial-outage-search/commercial-outages-search-container.component';

// App component imports this so it has access to everything it needs for
// the relevant tabs within the application
export const TAB_COMPONENTS = [
  MainContainerComponent,
  MonlogsDetailContainerComponent,
  MonLogPrintContainerComponent,
  MonlogsAllLogsSearchContainerComponent,
  OplogsDetailContainerComponent,
  OpAlertLogPrintContainerComponent,
  OplogsAllLogsSearchContainerComponent,
  FacilityContainerComponent,
  FacilityDetailsContainerComponent,
  LocationContainerComponent,
  ContactProfileContainerComponent,
  ContactsSearchContainerComponent,
  ContactDetailsContainerComponent,
  ContactListSearchContainerComponent,
  ContactListDetailViewContainerComponent,
  ExternalContactListDetailsContainerComponent,
  ExternalContactListSearchContainerComponent,
  NoteFormComponent,
  SapOutageReportComponent,
  ReadOnlySapViewComponent,
  McLogSearchComponent,
  McLogDetailsComponent,
  MonlogsSearchContainerComponent,
  AlarmLimitsSearchContainerComponent,
  SyncAlarmLimitsContainerComponent,
  StationLogsSearchContainerComponent,
  MusterListSearchContainerComponent,
  McShiftTurnoverContainerComponent,
  McShiftTurnoverDetailComponent,
  McShiftTurnoverPrintContainerComponent,
  ContactListCreateContainerComponent,
  GisMapComponent,
  FieldVisionEmbedComponent,
  ControllerNotesContainerComponent,
  NoteFormComponent,
  DailyOperatingPlansContainerComponent,
  AorViewComponent,
  CrmShiftTurnoverContainerComponent,
  CrmShiftTurnoverDetailsContainerComponent,
  CrmShiftTurnoverPrintContainerComponent,
  EmailGroupContainerComponent,
  MonLogTypesContainerComponent,
  NoteTypesContainerComponent,
  JobRolesContainerComponent,
  CompanyContainerComponent,
  MocEventSearchContainerComponent,
  MocEventDetailsContainerComponent,
  MocEventCategoryContainerComponent,
  RoleClaimAssignContainerComponent,
  ClaimRoleAssignContainerComponent,
  RoleBusinessUnitAssignContainerComponent,
  AreaContainerComponent,
  AreaDetailsContainerComponent,
  RegionContainerComponent,
  RegionDetailsContainerComponent,
  SapOutageReportComponent,
  PartsSearchContainerComponent,
  TroubleshootingSearchContainerComponent,
  MobileControllerNotesSearchComponent,
  MobileNoteFormComponent,
  FacilityVisitorLogComponent,
  CommercialContactsSearchContainerComponent,
  CommercialContactDetailsContainerComponent,
  CommercialFacilitiesSearchContainerComponent,
  CommercialFacilityDetailsContainerComponent,
  CommercialOutagesSearchContainerComponent,
];
